import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const methods = [{
  title: 'El castigo',
  quote: '"Si no te calmas, te quedas sin tablet."',
  whyFails: 'cuando el niño está en pleno colapso emocional, el cerebro racional está apagado.',
  result: 'El castigo no llega. Solo añade miedo sobre el caos.'
}, {
  title: 'La explicación lógica',
  quote: '"Hijo, entiende que no podemos comprarlo todo..."',
  whyFails: 'un niño desbordado no puede procesar un discurso.',
  result: 'La puerta de la razón está cerrada con llave desde adentro.'
}, {
  title: 'El soborno',
  quote: '"Si dejas de llorar te doy un dulce."',
  whyFails: 'enseña al niño que el berrinche es la moneda de cambio para conseguir lo que quiere.',
  result: 'Lo entrenas sin darte cuenta.'
}, {
  title: 'Gritar más fuerte',
  quote: 'Lo intentaste. Sabes que no funciona.',
  whyFails: 'Solo demuestra que cuando alguien pierde el control en casa, el que lo hace más fuerte gana temporalmente.',
  result: 'Esa no es la lección que quieres dar.'
}];
export function TraditionalMethods() {
  return <SectionWrapper className="bg-cream py-20" constrained={false} data-id="element-303">
      <div className="max-w-4xl mx-auto px-6" data-id="element-304">
        <h2 className="font-sans text-3xl md:text-4xl font-bold text-ink mb-12 text-center" data-id="element-305">
          Probablemente ya intentaste algunas de estas cosas:
        </h2>

        <div className="grid md:grid-cols-2 gap-8 mt-12 mb-16" data-id="element-306">
          {methods.map((method, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-soft border-t-4 border-t-softred flex flex-col" data-id="element-307">
              <h3 className="font-sans text-xl font-bold text-ink mb-4 flex items-center gap-2" data-id="element-308">
                <span className="text-softred" data-id="element-309">❌</span> {method.title}
              </h3>

              <div className="bg-cream-dark p-4 rounded-lg mb-6" data-id="element-310">
                <p className="font-sans text-ink-mid italic text-center" data-id="element-311">
                  {method.quote}
                </p>
              </div>

              <div className="space-y-4 flex-grow" data-id="element-312">
                <div data-id="element-313">
                  <p className="font-sans font-bold text-ink mb-1" data-id="element-314">
                    🧠 Por qué falla:
                  </p>
                  <p className="font-sans text-ink-mid leading-relaxed" data-id="element-315">
                    {method.whyFails}
                  </p>
                </div>
                <div data-id="element-316">
                  <p className="font-sans font-bold text-ink mb-1" data-id="element-317">
                    📉 Resultado real:
                  </p>
                  <p className="font-sans text-ink-mid leading-relaxed" data-id="element-318">
                    {method.result}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center space-y-6 max-w-2xl mx-auto" data-id="element-319">
          <p className="font-sans text-lg text-ink-mid" data-id="element-320">
            Ninguno de estos métodos falla porque seas mal padre o mala madre.
          </p>
          <p className="font-sans text-xl font-bold text-ink" data-id="element-321">
            Fallan porque atacan el síntoma en lugar del origen.
          </p>
          <p className="font-sans text-lg text-ink-mid" data-id="element-322">
            El origen es este: tu hijo no está eligiendo portarse mal. Está
            teniendo un colapso del sistema nervioso.
          </p>
          <p className="font-sans text-lg text-ink-mid" data-id="element-323">
            Y un colapso del sistema nervioso no se resuelve con lógica,
            amenazas ni premios.
          </p>
          <p className="font-sans text-3xl font-bold text-coral mt-8" data-id="element-324">
            Se resuelve con regulación.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}